import styled from "styled-components";

import awardBg from '@/images/day-award-box.png'
import awardBgHover from '@/images/day-award-box-hover.png'

const View = styled.div`
  position: absolute;
  right: 0;
  top: 18px;
  width: 520px;
  height: 452px;
  padding-top: 80px;
  padding-left: 27px;

  div.taskItem {
    position: relative;
    height: 95px;
    width: 100%;
    margin-bottom: 7px;

    & > p {
      vertical-align: top;
      width: 133px;
      line-height: 130px;
      text-align: center;
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      // background: linear-gradient(to bottom, #fffffb, #fffcce, #fff88e);
      // -webkit-background-clip: text;
      // background-clip: text;
      // -webkit-text-fill-color: transparent;
      // color: transparent;
      color: #fff71d;
      // -webkit-text-stroke: 1px #0889e0;
      // text-stroke: 1px #0889e0;
      text-shadow: 
        2px 0px 0px #0889e0, -2px 0px 0px #0889e0, /* 左右 */
        0px 2px 0px #0889e0, 0px -2px 0px #0889e0, /* 上下 */
        2px 2px 0px #0889e0, -2px -2px 0px #0889e0, /* 对角线 */
        2px -2px 0px #0889e0, -2px 2px 0px #0889e0;
    }

    ul {
      text-align: center;
      display: inline-block;
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      li {
        display: inline-block;
        width: 77px;
        height: 79px;
        position: relative;
        background-image: url("${awardBg}");
        cursor: pointer;
        transition: all 0.15s;
        margin: 12px 2px 0;

        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
          p {
            color: #0889e0;
          }
        }

        &.normal {
          &:hover {
            background-image: url("${awardBg}");
          }
        }

        img {
          width: 44px;
          height: 45px;
          position: absolute;
          left: 50%;
          top: 7px;
          transform: translateX(-50%);
        }

        p {
          color: #0889e0;
          font-weight: bold;
          position: absolute;
          bottom: 6px;
          width: 100%;
          font-size: 12px;
        }
      }
    }
  }

  p.tip {
    cursor: pointer;
    position: absolute;
    bottom: 12px;
    left: 0;
    padding: 0 36px 0 30px;
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    line-height: 28px;

    span:nth-child(1) {
      color: #009cfa;
      float: left;
    }

    span:nth-child(2) {
      float: right;
      text-decoration: underline;
      color: #e40429;
    }
  }

  .button {
    position: relative;
    top: 0px;
  }
`;

export {
  View
}
